import {
  ConnectedDlpSecondaryProductSummary,
  ConnectedDlpSecondaryTradeInformation,
} from 'components/Workspaces/SecondaryMarketQuotes/Tabs/dlpOrder';
import { FC } from 'react';

import './dlpOrder.scss';
export type DlpOrderFormContentProps = Readonly<{
  tabId: string;
}>;

export const DlpOrderFormContent: FC<DlpOrderFormContentProps> = ({ tabId }) => (
  <>
    <ConnectedDlpSecondaryProductSummary tabId={tabId} />
    <ConnectedDlpSecondaryTradeInformation tabId={tabId} />
  </>
);
